/**
 * SEÇÃO 11: CTA FINAL
 * 
 * Repete a oferta principal antes do rodapé.
 * Preço: De R$147 por R$97 • Por 1 pessoa • 12 meses de validade
 */

import { memo } from "react";
import { Check, ArrowRight } from "lucide-react";

export const FinalCTASection = memo(({ sectionRef, isVisible, onOpenPalpiteModal }) => {
  return (
    <section 
      ref={sectionRef}
      className={`py-12 md:py-16 bg-gradient-to-b from-[#002776] to-[#001a4d] transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      data-testid="final-cta-section"
    >
      <div className="max-w-3xl mx-auto px-4 text-center">
        
        {/* Headline */}
        <h2 className="text-2xl md:text-3xl font-black text-white mb-6">
          NÃO DEIXE PRA DEPOIS
        </h2>
        
        {/* Benefícios em linha */}
        <div className="flex flex-wrap justify-center gap-3 mb-8">
          <span className="bg-white/10 text-white px-4 py-2 rounded-full text-sm font-medium">
            De R$147 por <strong className="text-[#FFDF00]">R$97</strong>
          </span>
          <span className="bg-white/10 text-white px-4 py-2 rounded-full text-sm font-medium">
            Por 1 pessoa
          </span>
          <span className="bg-white/10 text-white px-4 py-2 rounded-full text-sm font-medium">
            12 meses de validade
          </span>
          <span className="bg-white/10 text-white px-4 py-2 rounded-full text-sm font-medium">
            Não precisa saber nadar
          </span>
        </div>
        
        {/* Card de preço */}
        <div className="bg-white rounded-2xl p-6 shadow-xl max-w-md mx-auto mb-6">
          <div className="mb-4">
            <p className="text-gray-400 text-sm line-through">De R$ 147</p>
            <p className="text-[#002776] text-5xl font-black">R$ 97</p>
            <p className="text-gray-600 text-sm">ou 12x de R$ 10,03 sem juros</p>
          </div>
          
          <button
            onClick={onOpenPalpiteModal}
            className="w-full bg-gradient-to-r from-[#009C3B] to-[#007830] hover:from-[#007830] hover:to-[#006020] text-white font-black py-4 px-6 rounded-xl shadow-lg text-lg transition-all duration-300 hover:scale-[1.02]"
          >
            GARANTIR MEU PASSEIO — R$97
          </button>
          
          <div className="flex flex-wrap items-center justify-center gap-3 mt-4 text-gray-500 text-xs">
            <span className="flex items-center gap-1">
              <Check className="w-3 h-3 text-[#009C3B]" /> Pagamento seguro
            </span>
            <span className="flex items-center gap-1">
              <Check className="w-3 h-3 text-[#009C3B]" /> Garantia 30 dias
            </span>
          </div>
        </div>
        
        {/* Redes sociais */}
        <div className="mb-4">
          <a 
            href="https://instagram.com/mergulhobc" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors text-sm"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
            @mergulhobc (+40 mil seguidores)
          </a>
        </div>
        
      </div>
    </section>
  );
});

export default FinalCTASection;
